// Sanitize HTML to prevent XSS attacks

const ALLOWED_TAGS = [
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'p', 'br', 'span', 'div',
  'strong', 'em', 'u', 's', 'strike',
  'blockquote', 'pre', 'code',
  'ul', 'ol', 'li',
  'a', 'img',
  'table', 'thead', 'tbody', 'tr', 'th', 'td'
];

const ALLOWED_ATTRIBUTES = {
  'a': ['href', 'title', 'target', 'rel'],
  'img': ['src', 'alt', 'title', 'width', 'height'],
  '*': ['class', 'id']
};

export const sanitizeHtml = (html) => {
  if (!html) return '';

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  const sanitize = (node) => {
    Array.from(node.childNodes).forEach(child => {
      if (child.nodeType === Node.ELEMENT_NODE) {
        const tagName = child.tagName.toLowerCase();
        if (!ALLOWED_TAGS.includes(tagName)) {
          child.remove();
          return;
        }
        Array.from(child.attributes).forEach(attr => {
          const attrName = attr.name.toLowerCase();
          const allowedForTag = ALLOWED_ATTRIBUTES[tagName] || [];
          const allowedGlobal = ALLOWED_ATTRIBUTES['*'] || [];
          if (!allowedForTag.includes(attrName) && !allowedGlobal.includes(attrName)) {
            child.removeAttribute(attr.name);
          }
        });
        if (tagName === 'a') {
          const href = child.getAttribute('href');
          if (href && (href.startsWith('javascript:') || href.startsWith('data:'))) {
            child.removeAttribute('href');
          }
          child.setAttribute('target', '_self');
          child.removeAttribute('rel');
        }
        sanitize(child);
      }
    });
  };

  sanitize(doc.body);
  return doc.body.innerHTML;
};

export const sanitizeForDisplay = (html) => {
  if (!html) return '';
  let clean = html.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
  clean = clean.replace(/on\w+="[^"]*"/gi, '');
  clean = clean.replace(/on\w+='[^']*'/gi, '');
  clean = clean.replace(/javascript:/gi, '');
  clean = clean.replace(/\btarget="_blank"/gi, 'target="_self"');
  clean = clean.replace(/\brel="[^"]*"/gi, '');
  return clean;
};
